<div class="container m-auto flex flex-col justify-center items-center h-screen">
  <div *ngIf="loading">
    <fa-icon icon="circle-notch" [spin]="true" size="3x"></fa-icon>
  </div>

  <app-alert *ngIf="error"type="ERROR">
    {{error | json}}
  </app-alert>
</div>
